// DipField Suite entry. GPL-3.0-or-later.
import "./styles/fonts.css";
import "./styles/tokens.css";
import "./styles/app.css";
import "./styles/shell.css";
import { startShell } from "./shell/shell.js";

void startShell();
